import { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';

// import { useSinglePrismicDocument } from '@prismicio/react';
import { useQuery } from '@tanstack/react-query';
import { client } from '../../../prismic';

const ShopLinks = () => {
  const [shopLinks, setShopLinks] = useState([]);
  const { data } = useQuery({
    queryKey: ['shopLinksData'],
    queryFn: () => client.getSingle('shop_links'),
  });

  useEffect(() => {
    const shopLinksSet = shopLinks.length > 0;
    const shopLinksLoaded = data !== undefined;
    if (!shopLinksSet && shopLinksLoaded) {
      setShopLinks(formatResponse(data));
    }
  }, [shopLinks, data]);

  return (
    <div className='shop-links'>
      {shopLinks.map(link => {
        const { name, url } = link;
        const key = uuid();
        return (
          <a
            className='sidebar-link'
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            key={key}
          >
            {name}
          </a>
        );
      })}
    </div>
  );
};

const formatResponse = response => {
  const { data } = response;
  const { links } = data;

  const formattedLinks = links.map(link => {
    const { name, url } = link;

    return {
      name: name[0].text,
      url: url.url,
    };
  });

  return formattedLinks;
};

export default ShopLinks;
